import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { quizQuestionActions } from '@app/store/quiz-question/actions/quiz-question.actions';
import { quizQuestionsActions } from '../actions/quiz-questions.actions';
import { selectLastParams } from '../selectors/quiz-questions.selector';

@Injectable()
export class QuizQuestionQuizQuestionsBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    refreshOnMutation$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizQuestionActions.createQuizQuestionSuccess, quizQuestionActions.updateQuizQuestionSuccess, quizQuestionActions.deleteQuizQuestionSuccess),
            concatLatestFrom(() => this.store.select(selectLastParams)),
            map(([, lastParams]) => quizQuestionsActions.getQuizQuestions({ value: lastParams })),
        );
    });
}
